import React from "react";
import NormalText from "./NormalText";
import PrimaryButton from "./PrimaryButton";

type PatientInfoFormNoSubmitProps = {
  handleSubmit: (value: string) => void;
  collectWeigh?: boolean;
  collectHeight?: boolean;
  collectMessage?: boolean;
};

const PatientInfoFormNoSubmit: React.FC<PatientInfoFormNoSubmitProps> = ({
  handleSubmit,
  collectWeigh = false,
  collectHeight = false,
  collectMessage = false,
}) => {
  const [lbs, setLbs] = React.useState<number>();
  const [feet, setFeet] = React.useState<number>();
  const [inches, setInches] = React.useState<number>();
  const [message, setMessage] = React.useState<string>("");
  const [pressSubmit, setPressSubmit] = React.useState<boolean>(false);

  const [error, setError] = React.useState<string>("");

  const onSubmit = async () => {
    setError("");
    if (collectMessage) {
      if (message.trim().length < 3) {
        setError("Message must be at least 3 characters long.");
        return;
      }
      handleSubmit(message);
    }

    if (collectWeigh) {
      const weightIbs = Number(lbs);
      if (isNaN(weightIbs) || weightIbs < 50 || weightIbs > 500) {
        setError("Please enter a valid weight (50-500 lbs).");
        return;
      }
      handleSubmit(`${weightIbs} lbs`);
    }

    if (collectHeight) {
      const heightFeet = Number(feet);
      const heightInches = Number(inches);
      if (
        isNaN(heightFeet) ||
        heightFeet < 1 ||
        heightFeet > 10 ||
        isNaN(heightInches) ||
        heightInches < 0 ||
        heightInches > 11
      ) {
        setError("Please enter a valid height (Feet: 1-10, Inches: 0-11).");
        return;
      }
      handleSubmit(`${heightFeet}'${heightInches}"`);
    }

    setPressSubmit(true);
  };

  return (
    <div
      style={{
        gap: 10,
        width: "75%",
        display: "flex",
        borderRadius: 20,
        marginLeft: "auto",
        padding: "10px 20px",
        flexDirection: "column",
        border: "1px solid #C4C6CD",
      }}
    >
      {collectHeight && (
        <div style={{ display: "flex", gap: 15 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <NormalText textContent="Feet" />
            <input
              disabled={pressSubmit}
              type="number"
              value={feet}
              inputMode="numeric"
              required
              autoFocus
              style={{ fontSize: "16px", padding: "0 10px", ...styles.input }}
              // @ts-ignore
              onChange={(e) => setFeet(e.target.value)}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <NormalText textContent="Inches" />
            <input
              disabled={pressSubmit}
              type="number"
              value={inches}
              inputMode="numeric"
              required
              style={{ fontSize: "16px", padding: "0 10px", ...styles.input }}
              // @ts-ignore
              onChange={(e) => setInches(e.target.value)}
            />
          </div>
        </div>
      )}
      {collectWeigh && (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <NormalText textContent="Lbs" />
          <input
            disabled={pressSubmit}
            type="number"
            value={lbs}
            inputMode="numeric"
            required
            autoFocus
            style={{ fontSize: "16px", padding: "0 10px", ...styles.input }}
            // @ts-ignore
            onChange={(e) => setLbs(e.target.value)}
          />
        </div>
      )}
      {collectMessage && (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <textarea
            disabled={pressSubmit}
            value={message}
            placeholder="Type your message"
            required
            autoFocus
            style={{
              fontSize: 16,
              padding: 10,
              ...styles.input,
              height: 75,
            }}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
      )}
      {error && <NormalText textContent={error} style={styles.errorText} />}
      <PrimaryButton
        text={"Confirm"}
        type="button"
        disabled={pressSubmit}
        fullWidth
        useThemeColor={false}
        displayPoweredBy={false}
        onClick={onSubmit}
      />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  input: {
    fontWeight: 500,
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid #CACACA",
    height: "35px",
    borderRadius: "3px",
  },
  errorText: {
    color: "red",
    fontSize: "14px",
  },
} as const;

export default PatientInfoFormNoSubmit;
